import { JstDate } from '../../core/time/business-time';
import { jstDateString } from '../../shared/utils/jst-date';

export interface MonthOption { name: string; value: string; }

export function subscriptionMonths(kind: 'start' | 'stop', transactionDay = 11, now: Date = new JstDate()): MonthOption[] {
  const [year, month, day] = jstDateString(now).split('-').map(Number);
  const offset = kind === 'stop' && day >= transactionDay ? 1 : 0;
  return Array.from({ length: kind === 'start' ? 2 : 4 }, (_, index) => {
    // Use UTC only for calendar arithmetic; these are date-only API values.
    const date = new JstDate(Date.UTC(year, month - 1 + offset + index + (kind === 'stop' ? 1 : 0), kind === 'stop' ? 0 : 1));
    const value = date.toISOString().slice(0, 10);
    return { value, name: `${value.slice(0, 4)}年${value.slice(5, 7)}月` };
  });
}

export function deliveryDayLabel(value: any, emptyValue = '-'): string {
  return value === null || value === undefined || value === '' ? emptyValue : Number(value) === 0 ? '月末' : `${value}日`;
}

export function subscriptionLabel(item: any): string {
  const day = item?.deliveryDay;
  return [item?.product?.name, subscriptionMonthLabel(item?.startDate),
    day == null || day === '' ? '' : `引渡日：毎月${deliveryDayLabel(day)}`].filter(Boolean).join(' / ');
}

export function subscriptionMonthLabel(value: any): string {
  const date = value ? jstDateString(value) : '';
  return date ? `${date.slice(0, 4)}年${date.slice(5, 7)}月` : '';
}
